import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { breakpoints } from 'styles';
import { LoadingIndicator } from 'components/common';
import { Box } from 'components/common/box';
import { StatItem } from 'components/common/stats';

const AnalyticsOverviewContent = connect((state) => ({
  messages: state.messages,
  serverConfig: state.serverConfig,
  theme: state.theme
}))(
  class extends Component {
    state = {
      data: null,
      loading: false
    };

    componentDidMount() {
      this.updateData();
    }

    updateData = async () => {
      try {
        const response = await api.get('/admin/stats/content');
        this.setState({
          data: response.data.data,
          loading: false
        });
      } catch (err) {
        this.setState({ loading: false });
        await this.props.dispatch.handleErrorDispatch(err);
      }
    };

    render() {
      const { messages, serverConfig } = this.props;
      const { data, loading } = this.state;

      const coursesVisible = !serverConfig.hideCoursesFromUI;
      const pathsVisible = !serverConfig.hidePathsFromUI;

      return (
        <div className="content">
          {loading ? (
            <LoadingIndicator />
          ) : (
            <div className="numbers">
              <div className="row-sm">
                {coursesVisible && (
                  <div className="col-1of3">
                    <Box>
                      <div className="item">
                        <StatItem
                          align="left"
                          label={messages.commonCourses}
                          labelBefore={true}
                          value={data?.numberOfCourses}
                        />
                      </div>
                    </Box>
                  </div>
                )}
                {pathsVisible && (
                  <div className="col-1of3">
                    <Box>
                      <div className="item">
                        <StatItem
                          align="left"
                          label={messages.paths}
                          labelBefore={true}
                          value={data?.numberOfPaths}
                        />
                      </div>
                    </Box>
                  </div>
                )}
                <div className="col-1of3">
                  <Box>
                    <div className="item">
                      <StatItem
                        align="left"
                        label={messages.commonGroups}
                        labelBefore={true}
                        value={data?.numberOfGroups}
                      />
                    </div>
                  </Box>
                </div>
              </div>
            </div>
          )}

          <style jsx>{`
            .item {
              padding: 0 10px;
            }
            .blocks {
              margin-top: 20px;
            }
            .blocks-total {
              padding: 10px;
            }
            .blocks-detailed {
              display: flex;
              flex-wrap: wrap;
              margin: 0 -10px;
            }
            .blocks-detailed-list {
              padding: 0 10px;
              width: 100%;
            }
            @media (min-width: ${breakpoints.medium}px) {
              .blocks-detailed-list {
                width: 33.333%;
              }
            }
          `}</style>
        </div>
      );
    }
  }
);

export default AnalyticsOverviewContent;
